/**
 * 项目管理api
 */
export default {
  projectCategoryList: '/projectCategory/list', //分类列表
  selectProjectInfoList: '/projectInfo/selectProjectInfoList', //列表
  selectProjectInfoDetail: '/projectInfo/selectProjectInfoDetail', //详情
  selectProjectConfigList: '/projectInfo/selectProjectConfigList', //预约列表
  insertProject: '/projectInfo/insertProjectReservationConfig', //新增时间段
  updateProject: '/projectInfo/updateProjectReservationConfig', //修改时间段
  deleteProject: '/projectInfo/deleteProjectReservationConfig', //删除时间段
  updateProjectStatus: '/projectInfo/updateProjectConfigStatus', //状态变更
};
